<div class="input-unit-v1 timeFormatGroup" [class.disabled]="inputIsDisabled">
    <terra-select-box
        class="time"
        [(ngModel)]="_hours"
        [inputListBoxValues]="valuesHours"
        [inputName]="'timepicker.hours' | translate: _locale.language"
    >
    </terra-select-box>
    <terra-select-box
        class="time"
        [(ngModel)]="_minutes"
        [inputListBoxValues]="valuesMinutes"
        [inputName]="'timepicker.minutes' | translate: _locale.language"
    >
    </terra-select-box>
</div>
